import type { ComponentProps } from 'react'
import { cn } from '@/utils/cn'
import { XendrelMark } from './XendrelMark'

type AssistantGlyphProps = ComponentProps<typeof XendrelMark> & {
  /**
   * `foreground` (default) draws the glyph in the page's own ink. `inherit`
   * leaves it in the surrounding text color — on a filled button, or where the
   * control dims and lights its content itself.
   */
  ink?: 'foreground' | 'inherit'
}

/**
 * The glyph of the Xendrel Assistant: the brand mark, upright, in the foreground
 * ink. Everything that opens the assistant or speaks for it shows this one;
 * other AI actions keep the sparkle. Change how the assistant looks here.
 */
export function AssistantGlyph({ ink = 'foreground', className, ...props }: AssistantGlyphProps) {
  return (
    <XendrelMark className={cn(ink === 'foreground' && 'text-foreground', className)} {...props} />
  )
}
